export function flattenArrayObject(arr, prop) {
  let result = []
  arr.forEach((item) => {
    result.push(item)
    if (item[prop] && item[prop].length > 0) {
      result = result.concat(flattenArrayObject(item[prop], prop))
      // delete item[prop]
    }
  })
  return result
}
